<template>
  <div class="modal-form">
    <b-modal :id="id" :size="size" hide-footer centered>
      <div class="col-12 d-flex flex-column align-items-center">
        <div class="title-modal font-weight-bold">{{ title }}</div>
        <slot></slot>
      </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: "form-modal",
  props: {
    id: {
      default: "",
      type: String,
    },
    title: {
      default: "",
      type: String,
    },
    size: {
      default: "",
      type: String,
    },
  },
  emits: [],
  data() {
    return {};
  },
  beforeMount() {},
  methods: {},
};
</script>
<style lang="scss">
.title-modal {
  font-weight: 700 !important;
  font-size: 26px !important;
  line-height: 36px !important;

  text-align: center !important;
  letter-spacing: -0.02em !important;

  color: #263238 !important;

  flex: none !important;
  order: 0 !important;
  align-self: stretch !important;
  flex-grow: 0 !important;
}

.modal-header .close {
  font-weight: 500;
  font-size: 32px;
  text-transform: uppercase;
  color: blue;
}
</style>